<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a>Jews and the Civil War</h1>
<p class="subtitle"><em>A Reader</em></p>
<p class="editor"><span class="small">EDITED BY</span><br/><em>Jonathan D. Sarna and Adam Mendelsohn</em></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?f4371942